var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            attrs: {
              label: "Possui reserva legal?",
              content: _vm.formataPossuiReservaLegal(
                _vm.usoDoSolo.possuiReservaLegal
              )
            }
          }),
          _vm._v(" "),
          _c("app-display", {
            attrs: {
              label: "Destinação do imóvel:",
              content: _vm.formataDestinacaoDoImovel(
                _vm.usoDoSolo.destinacoesImovel
              )
            }
          }),
          _vm._v(" "),
          _c("app-display", {
            attrs: {
              label: "Destinação da produção:",
              content: _vm.usoDoSolo.destinacaoProducao
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            attrs: {
              label: "Fornecedor de alguma empresa:",
              content: _vm.usoDoSolo.hasFornecedoras ? "Sim" : "Não"
            }
          }),
          _vm._v(" "),
          _vm.usoDoSolo.hasFornecedoras
            ? _c("app-display", {
                attrs: {
                  label: "Empresas:",
                  content: _vm.formataEmpresas(
                    _vm.usoDoSolo.empresasFornecedoras
                  )
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "title-uso-do-solo" }, [
        _vm._v("Dados do uso do solo")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b49957b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b49957b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/UsoDoSolo/UsoDoSolo.vue
// module id = null
// module chunks = 